/* build/tpl */
import deps from './deps/mapKeysDeep.js';
import getMapKeysDeep from './getMapKeysDeep.js';
export default getMapKeysDeep(deps);
